/* eslint-disable react/no-array-index-key */
import React, { useCallback, useEffect, useState } from 'react';
import { Row, Col, Switch } from 'antd';
import { MdRemove, MdAdd } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import AnimateHeight from 'react-animate-height';
import { format } from 'date-fns';
import * as actions from '~/store/modules/indicators/actions';

import {
  Container,
  BoxListItem,
  BoxButtonList,
  ButtonList,
  BoxIndicators,
  BoxIndicatorsTitle,
  SwitchButton,
  BoxStratifications,
} from './style';

import {
  modalConfirmIndicador,
  modalCancelIndicador,
  modalConfirmEstrat,
  modalCancelEstrat,
} from '../../optionsModal';

const IndicadorList = ({ idLocation }) => {
  const dispath = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState([]);

  const [activeStrats, setActiveStrats] = useState([]);

  const { indicatorsPgData } = useSelector(state => state.indicators);
  const { institutionId, roles } = useSelector(state => state.auth);

  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');

  const [data, setData] = useState([]);

  //  Toogle: Lista de Estratificações
  const [openStrat, setOpenStrat] = useState([]);

  useEffect(() => {
    if (indicatorsPgData) {
      const indicators = new Set();
      const filteredIndicators = indicatorsPgData.filter(item => {
        const duplicate = indicators.has(item.idIndicador);
        indicators.add(item.idIndicador);
        return !duplicate;
      });

      setData(filteredIndicators);
    }
  }, [indicatorsPgData]);

  useEffect(() => {
    dispath(
      actions.getIndicatorsPgRequest({
        id: ROLE_ADMIN ? idLocation : institutionId,
      })
    );
  }, [ROLE_ADMIN, dispath, idLocation, institutionId]);

  const handleOpen = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const requestActive = useCallback(
    ({ itemData }) => {
      const { idIndicador, idInstituicao, dtInicioColeta } = itemData;

      const datas = {
        dtFimColeta: format(new Date(), 'yyyy-MM-dd'),
        dtInicioColeta,
      };

      dispath(
        actions.activeIndicatorsPgRequest({ idIndicador, idInstituicao, datas })
      );
    },
    [dispath]
  );

  const requestInactive = useCallback(
    ({ itemData }) => {
      const { idIndicador, idInstituicao, dtInicioColeta } = itemData;

      const datas = {
        dtFimColeta: format(new Date(), 'yyyy-MM-dd'),
        dtInicioColeta,
      };

      dispath(
        actions.inactiveIndicatorsPgRequest({
          idIndicador,
          idInstituicao,
          datas,
        })
      );
    },
    [dispath]
  );

  const activeIndicator = useCallback(
    ({ status, itemId, itemData }) => {
      if (status) {
        Swal.fire(modalConfirmIndicador).then(result => {
          if (result.value) {
            setActive([...active, itemId]);
            requestActive({ itemData });
          }
        });
        return;
      }

      Swal.fire(modalCancelIndicador).then(result => {
        if (result.value) {
          setActive(active.filter(item => item !== itemId));
          requestInactive({ itemData });
        }
      });
    },
    [active, requestActive, requestInactive]
  );

  // ESTRATIFICAÇÕES

  const requestActiveEstrat = useCallback(
    ({ itemEstratificacao }) => {
      const { id, idInstituicao, dtInicioColeta } = itemEstratificacao;

      const datas = {
        dtFimColeta: format(new Date(), 'yyyy-MM-dd'),
        dtInicioColeta,
      };

      dispath(actions.activeEstratRequest({ id, idInstituicao, datas }));
    },
    [dispath]
  );

  const requestInactiveEstrat = useCallback(
    ({ itemEstratificacao }) => {
      const { id, idInstituicao, dtInicioColeta } = itemEstratificacao;

      const datas = {
        dtFimColeta: format(new Date(), 'yyyy-MM-dd'),
        dtInicioColeta,
      };

      dispath(actions.inactiveEstratRequest({ id, idInstituicao, datas }));
    },
    [dispath]
  );

  const handleActiveEstratificacao = useCallback(
    ({ status, itemEstratificacao }) => {
      const { id } = itemEstratificacao;

      if (status) {
        Swal.fire(modalConfirmEstrat).then(result => {
          if (result.value) {
            setActiveStrats([...activeStrats, id]);
            requestActiveEstrat({ itemEstratificacao });
          }
        });

        return;
      }

      Swal.fire(modalCancelEstrat).then(result => {
        if (result.value) {
          setActiveStrats(activeStrats.filter(item => item !== id));
          requestInactiveEstrat({ itemEstratificacao });
        }
      });
    },
    [activeStrats, requestActiveEstrat, requestInactiveEstrat]
  );

  const getStratifications = useCallback(
    idIndicador => {
      return indicatorsPgData.filter(
        indicator => indicator.idIndicador === idIndicador
      );
    },
    [indicatorsPgData]
  );

  const handleOpenStrat = useCallback(
    itemId => {
      setOpenStrat([...openStrat, itemId]);
    },
    [openStrat]
  );
  const handleCloseStrat = useCallback(
    itemId => {
      setOpenStrat(openStrat.filter(item => item !== itemId));
    },
    [openStrat]
  );

  const indicadorIsActive = useCallback(
    itemData => {
      const { idIndicador } = itemData;

      const iData = indicatorsPgData.filter(i => i.idIndicador === idIndicador);

      if (iData.find(i => i.ativo === true)) {
        return true;
      }

      return false;
    },
    [indicatorsPgData]
  );

  return (
    <Container>
      <BoxListItem>
        <div className="indicador">
          <button type="button" onClick={handleOpen}>
            <ButtonList isOpen={isOpen}>
              {isOpen ? <MdRemove size={20} /> : <MdAdd size={20} />}
            </ButtonList>
          </button>
          <button type="button" onClick={handleOpen}>
            <span>Painel Geral – status dos indicadores</span>
          </button>
        </div>
        <div className="coleta" />
        <div className="coleta" />
        <div className="status" />
      </BoxListItem>

      {isOpen && (
        <BoxIndicators>
          <BoxIndicatorsTitle>
            <Row>
              <Col span={11}>
                <p>Nome do indicador</p>
              </Col>
              <Col span={5}>
                <p>Início da coleta</p>
              </Col>

              <Col span={5}>
                <p>Fim da coleta</p>
              </Col>

              <Col span={3}>
                <p>Status do indicador</p>
              </Col>
            </Row>
          </BoxIndicatorsTitle>

          {data.length > 0 &&
            data.map((itemData, index) => {
              const { nomeCompleto, idIndicador } = itemData;
              const itemId = `${idIndicador}-${index}`;

              const isActive = indicadorIsActive(itemData);

              const isToogle = openStrat.includes(itemId);

              return (
                <div
                  className="itemBoxIndicators"
                  key={`${idIndicador}-${index}`}
                >
                  <Row>
                    <Col span={7}>
                      <BoxButtonList
                        onClick={() =>
                          isToogle
                            ? handleCloseStrat(itemId)
                            : handleOpenStrat(itemId)
                        }
                      >
                        <ButtonList isOpen={isToogle}>
                          {isToogle ? (
                            <MdRemove size={20} />
                          ) : (
                            <MdAdd size={20} />
                          )}
                        </ButtonList>

                        <p>{nomeCompleto}</p>
                      </BoxButtonList>
                    </Col>
                    <Col span={14} />

                    <Col span={3}>
                      <SwitchButton isActive={isActive}>
                        <Switch
                          checked={isActive}
                          onChange={status =>
                            activeIndicator({ status, itemId, itemData })
                          }
                        />
                        <b>{isActive ? 'Ativo' : 'Inativo'}</b>
                      </SwitchButton>
                    </Col>
                  </Row>

                  <AnimateHeight duration={300} height={isToogle ? 'auto' : 0}>
                    <BoxStratifications>
                      {getStratifications(idIndicador).map(
                        ({
                          nomeEstratificacao,
                          id,
                          idInstituicao,
                          ativo,
                          hint,
                          dtFimColeta,
                          dtInicioColeta,
                        }) => {
                          const itemEstratificacao = {
                            id,
                            idInstituicao,
                            dtInicioColeta,
                          };

                          return (
                            <div
                              key={`${id}-${nomeEstratificacao}`}
                              className="stratItem"
                            >
                              <Row>
                                <Col span={11}>
                                  <div style={{ paddingRight: 20 }}>
                                    <p>{nomeEstratificacao}</p>

                                    <span>{hint}</span>
                                  </div>
                                </Col>

                                <Col span={5}>
                                  <div className="stratDates">
                                    <span>
                                      {dtInicioColeta &&
                                        format(
                                          new Date(
                                            dtInicioColeta.replace('-', ',')
                                          ),
                                          'MM/yyyy'
                                        )}
                                    </span>
                                  </div>
                                </Col>

                                <Col span={5}>
                                  <div className="stratDates">
                                    <span>
                                      {dtFimColeta &&
                                        !ativo &&
                                        format(
                                          new Date(
                                            dtFimColeta.replace('-', ',')
                                          ),
                                          'MM/yyyy'
                                        )}
                                    </span>
                                  </div>
                                </Col>

                                <Col span={3}>
                                  {getStratifications(idIndicador).length >
                                    1 && (
                                    <div className="switchAndTolltip">
                                      <SwitchButton isActive={ativo}>
                                        <Switch
                                          size="small"
                                          checked={ativo}
                                          onChange={status =>
                                            handleActiveEstratificacao({
                                              status,
                                              itemEstratificacao,
                                            })
                                          }
                                        />
                                        <b>{ativo ? 'Ativo' : 'Inativo'}</b>
                                      </SwitchButton>
                                    </div>
                                  )}
                                </Col>
                              </Row>
                            </div>
                          );
                        }
                      )}
                    </BoxStratifications>
                  </AnimateHeight>
                </div>
              );
            })}
        </BoxIndicators>
      )}
    </Container>
  );
};

export default React.memo(IndicadorList);
